var map = {
	"./music-instructions.json": 4822,
	"./music-library-intro2024.json": 4823,
	"./music-library-launch2024.json": 4824,
	"./music-progression.json": 4825,
	"./startSourcesAdvanced.json": 4826,
	"./startSourcesSimple.json": 4827,
	"./startSourcesSimple2.json": 4828,
	"./startSourcesTracks.json": 4829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4519;